import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import difference from 'lodash/difference';
import classificationModel from './../classificationManage/classificationModel.vue';
import { addClaimsItem, editClaimsItem } from './request.js';
import parameterModal from './../parameterManage/addModal.vue';
import demageModal from './../demageManage/addModal.vue';
import previewListModal from './../demageManage/previewListModal.vue';
import { claimsDocumentDetail } from './../demageManage/request';
export default {
  components: {
    classificationModel,
    parameterModal,
    demageModal,
    previewListModal
  },
  props: ['infoObj', 'documentList', 'claimsList', 'claimsParamList', 'insuranceId'],
  data() {
    return {
      itemIndex: null,
      selectedAll: false,
      parameterList: [],
      demageList: [],
      mockData: [],
      targetKeys: [],
      columns: [{
        slots: {
          title: '文件名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '模版'
        },
        dataIndex: 'template',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'template'
        }
      }],
      columns1: [{
        slots: {
          title: '文件名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }],
      classificationShow: false,
      previewVisible: false,
      fileList: []
    };
  },
  watch: {
    documentList() {
      this.mockData = this.documentList.map(item => {
        item.key = String(item.claimsDocumentId);
        item.title = item.name;
        return item;
      });
    },
    claimsParamList() {
      this.handleClaimsParamChange();
    }
  },
  computed: {
    dataRule() {
      return {
        claimsDocument: [{
          required: true,
          trigger: 'change',
          validator: this.validateClaimsDocument
        }],
        claimsSort: [{
          required: true,
          validator: this.validateClaimsSort
        }],
        claimsTypeSort: [{
          required: true,
          trigger: 'blur',
          validator: this.validateClaimsTypeSort
        }]
      };
    }
  },
  created() {
    setTimeout(() => {
      if (this.infoObj.insuranceClaimsId) {
        this.arrangementDataFun();
      }
      if (this.documentList) {
        this.mockData = this.documentList.map(item => {
          item.key = String(item.claimsDocumentId);
          item.title = item.name;
          return item;
        });
      } else {
        this.mockData = [];
      }
      console.log(this.mockData, 22);
    }, 400);
  },
  methods: {
    validateClaimsSort(rule, value, callback) {
      let arr = [];
      this.infoObj.config.claimsSort.map(item => {
        item.claimsParamList.map(item2 => {
          if (item2.selected) {
            arr.push(item2);
          }
        });
      });
      if (arr.length == 0) {
        callback(new Error(this.$t('请选择') + this.$t('理赔单参数')));
      } else {
        callback();
      }
    },
    validateClaimsDocument(rule, value, callback) {
      if (this.targetKeys.length == 0) {
        callback(new Error(this.$t('请选择') + this.$t('索赔文件')));
      } else {
        callback();
      }
    },
    validateClaimsTypeSort(rule, value, callback) {
      if (!this.infoObj.claimsTypeSort) {
        callback(new Error(this.$t('请填写排序')));
      } else {
        callback();
      }
    },
    arrangementDataFun(arr) {
      this.demageList = [];
      if (arr) {
        console.log(arr, 11112);
        arr.map(item => {
          let arr = this.documentList.filter(item2 => item2.claimsDocumentId == item);
          if (arr.length != 0) {
            this.demageList.push(arr[0]);
          }
        });
      } else if (this.infoObj.config.claimsDocument.length != 0) {
        this.infoObj.config.claimsDocument.map(item => {
          let arr = this.documentList.filter(item2 => item2.claimsDocumentId == item);
          if (arr.length != 0) {
            this.demageList.push(arr[0]);
            this.targetKeys.push(String(arr[0].claimsDocumentId));
          }
        });
        console.log(this.targetKeys);
      }
    },
    previewFun(val) {
      claimsDocumentDetail({
        claimsDocumentId: val.claimsDocumentId
      }).then(res => {
        console.log(val);
        this.previewVisible = true;
        this.fileList = res.fileList.map((i, index) => {
          i.status = 'done';
          i.uid = index + 1;
          return i;
        });
      });
    },
    selectedAllFun(index) {
      this.infoObj.config.claimsSort[index].claimsParamList.map(item => {
        item.selected = this.infoObj.config.claimsSort[index].selected;
      });
    },
    openFun(index) {
      this.infoObj.config.claimsSort[index].isOpen = !this.infoObj.config.claimsSort[index].isOpen;
      let num = this.infoObj.config.claimsSort[index].isOpen ? this.infoObj.config.claimsSort[index].claimsParamList : 9;
      this.infoObj.config.claimsSort[index].claimsParamList.map((item, index) => {
        item.isOpen = index > num ? false : true;
      });
    },
    getRowSelection({
      disabled,
      selectedKeys,
      itemSelectAll,
      itemSelect
    }) {
      return {
        getCheckboxProps: item => ({
          props: {
            disabled: disabled || item.disabled
          }
        }),
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows.filter(item => !item.disabled).map(({
            key
          }) => key);
          const diffKeys = selected ? difference(treeSelectedKeys, selectedKeys) : difference(selectedKeys, treeSelectedKeys);
          itemSelectAll(diffKeys, selected);
        },
        onSelect({
          key
        }, selected) {
          itemSelect(key, selected);
        },
        selectedRowKeys: selectedKeys
      };
    },
    handleChange(nextTargetKeys) {
      console.log(nextTargetKeys);
      this.targetKeys = nextTargetKeys;
    },
    handleClaimsParamChange() {
      let arr = [];
      this.infoObj.claimsParam.map(item => {
        let arr2 = this.infoObj.config.claimsSort.filter(item2 => item2.sortId == item);
        if (arr2.length != 0) {
          arr.push(arr2[0]);
        } else {
          let name = this.claimsList.filter(item2 => item2.id == item);
          console.log(name, this.claimsParamList);
          let list = this.claimsParamList.map((item, index) => {
            let obj = {
              isOpen: index > 9 ? false : true,
              id: item.claimsParamId,
              selected: false,
              name: item.name
            };
            return obj;
          });
          arr.push({
            claimsParamList: list,
            sortId: item,
            claimsSortName: name[0].name,
            isOpen: this.claimsParamList.length > 9 ? false : true
          });
        }
      });
      this.infoObj.config.claimsSort = arr;
      console.log(this.infoObj.config.claimsSort);
    },
    handleClaimsParamItemChange(index, index2) {
      this.infoObj.config.claimsSort[index].claimsParamList[index2].selected = !this.infoObj.config.claimsSort[index].claimsParamList[index2].selected;
      let arr = this.infoObj.config.claimsSort[index].claimsParamList.filter(item => item.selected);
      this.infoObj.config.claimsSort[index].selected = arr.length == this.infoObj.config.claimsSort[index].claimsParamList.length ? true : false;
    },
    handleSave() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let obj = {
            insuranceId: this.insuranceId,
            insuranceClaimsId: this.infoObj.insuranceClaimsId || '',
            claimsTypeId: this.infoObj.claimsTypeId,
            config: {
              claimsDocument: this.initFun(this.targetKeys),
              claimsSort: this.getClaimsSortFun()
            },
            claimsTypeSort: this.infoObj.claimsTypeSort
          };
          let fun = this.infoObj.insuranceClaimsId ? editClaimsItem : addClaimsItem;
          fun(obj).then(res => {
            this.$message.success(this.$t('操作成功'));
            this.arrangementDataFun(this.targetKeys);
            this.$emit('info');
          });
        }
      });
    },
    initFun(arr) {
      let arr2 = arr.map(item => {
        return Number(item);
      });
      return arr2;
    },
    addClassificationFun() {
      this.classificationShow = true;
      this.$nextTick(() => {
        this.$refs.classificationFrom.init(false, true);
      });
    },
    classificationFun(val) {
      this.infoObj.claimsParam.push(val.claimsSortId);
      this.$emit('classification');
      setTimeout(() => {
        this.handleClaimsParamChange();
      }, 1000);
    },
    addParameterFun(index) {
      this.itemIndex = index;
      this.$refs.parameterRef.openModal('add', false, false);
    },
    parameterOk(val) {
      this.infoObj.config.claimsSort.map((item, index) => {
        let obj = {
          isOpen: true,
          id: val.claimsParamId,
          selected: index == this.itemIndex ? true : false,
          name: val.name
        };
        item.claimsParamList.unshift(obj);
        item.claimsParamList.map((item2, index2) => {
          if (item2.isOpen) {
            item2.isOpen = true;
          } else {
            item2.isOpen = index2 > 9 ? false : true;
          }
          return item2;
        });
        return item;
      });
      this.$emit('parameter');
    },
    getClaimsSortFun() {
      let arr = [];
      this.infoObj.config.claimsSort.map(item => {
        let claimsParamList = item.claimsParamList.filter(item2 => item2.selected);
        let obj = {};
        if (claimsParamList.length != 0) {
          obj.sortId = item.sortId;
          obj.claimsParam = [];
          claimsParamList.map(item3 => {
            obj.claimsParam.push(item3.id);
          });
          arr.push(obj);
        }
      });
      return arr;
    },
    addDemageFun() {
      this.$refs.demageRef.openModal('add', false, false);
    },
    demageOk(val) {
      this.targetKeys.push(String(val.claimsDocumentId));
      this.$emit('demage');
    }
  }
};